<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2>ApiDomains</h2>
          <div v-for="(link, key) in apiDomains" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">Link {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="apiDomains[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5">Tracking Domains</h2>
          <div v-for="(link, key) in trackingDomains" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">Domain {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="trackingDomains[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="form-label mt-5">tutorialUrl</h2>
          <input type="text" v-model="tutorialUrl" class="form-input"/>
          <h2 class="form-label mt-5">copyDownloadLink</h2>
          <input type="text" v-model="copyDownloadLink" class="form-input"/>
          <h2 class="form-label mt-5">onboardingImage2</h2>
          <input type="text" v-model="onboardingImage2" class="form-input"/>
          <h2 class="form-label mt-5">purchaseImg1</h2>
          <input type="text" v-model="purchaseImg1" class="form-input"/>
          <h2 class="form-label mt-5">qrPurchaseImageRight</h2>
          <input type="text" v-model="qrPurchaseImageRight" class="form-input"/>
          <h2 class="form-label mt-5">qrPurchaseImageLeft</h2>
          <input type="text" v-model="qrPurchaseImageLeft" class="form-input"/>
          <h2 class="form-label mt-5">qrWechatButtonIcon</h2>
          <input type="text" v-model="qrWechatButtonIcon" class="form-input"/>
          <h2 class="form-label mt-5">purchasePopupAlipayImage</h2>
          <input type="text" v-model="purchasePopupAlipayImage" class="form-input"/>
          <h2 class="form-label mt-5">purchasePopupWechatImage</h2>
          <input type="text" v-model="purchasePopupWechatImage" class="form-input"/>
          <h2 class="form-label mt-5">accountSupportImage</h2>
          <input type="text" v-model="accountSupportImage" class="form-input"/>
          <h2 class="form-label mt-5">tutorialImage2</h2>
          <input type="text" v-model="tutorialImage2" class="form-input"/>
          <h2 class="form-label mt-5">tutorialImage3</h2>
          <input type="text" v-model="tutorialImage3" class="form-input"/>
          <h2 class="form-label mt-5">tutorialImage4</h2>
          <input type="text" v-model="tutorialImage4" class="form-input"/>
          <h2 class="form-label mt-5">tutorialImage5</h2>
          <input type="text" v-model="tutorialImage5" class="form-input"/>
          <h2 class="form-label mt-5">tutorialImage6</h2>
          <input type="text" v-model="tutorialImage6" class="form-input"/>
          <h2 class="form-label mt-5">tutorialImage7</h2>
          <input type="text" v-model="tutorialImage7" class="form-input"/>
          <h2 class="form-label mt-5">tutorialImage8</h2>
          <input type="text" v-model="tutorialImage8" class="form-input"/>
          <h2 class="form-label mt-5">turorialGuideVideoUrl</h2>
          <input type="text" v-model="turorialGuideVideoUrl" class="form-input"/>
          <h2 class="form-label mt-5">weblinks</h2>
          <div v-for="(link, key) in weblinks" :key="'form-' + key">
            <div>
              <input :id="'input-' + key" type="text" v-model="weblinks[key].link" class="form-input"/>
            </div>
          </div>
          <h2 class="form-label mt-5">tutorialPagesNew</h2>
          <div v-for="(link, key) in tutorialPagesNew" :key="'form-' + key">
            <div v-if="containsImage(key)">
              <input :id="'input-' + key" type="text" v-model="tutorialPagesNew[key]" class="form-input"/>
            </div>
          </div>
          <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
            Save Api Domains
          </loading-button>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    guid: String,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      guid: this.guid,
      apiDomains: this.config.apiDomains,
      trackingDomains: this.config.trackingDomains,
      tutorialUrl: this.config.tutorialUrl,
      copyDownloadLink:this.config.copyDownloadLink,
      onboardingImage2:this.config.onboardingImage2,
      purchaseImg1:this.config.purchaseImg1,
      qrPurchaseImageRight:this.config.qrPurchaseImageRight,
      qrPurchaseImageLeft:this.config.qrPurchaseImageLeft,
      qrWechatButtonIcon:this.config.qrWechatButtonIcon,
      purchasePopupAlipayImage:this.config.purchasePopupAlipayImage,
      purchasePopupWechatImage:this.config.purchasePopupWechatImage,
      accountSupportImage:this.config.accountSupportImage,
      tutorialImage2:this.config.tutorialImage2,
      tutorialImage3:this.config.tutorialImage3,
      tutorialImage4:this.config.tutorialImage4,
      tutorialImage5:this.config.tutorialImage5,
      tutorialImage6:this.config.tutorialImage6,
      tutorialImage7:this.config.tutorialImage7,
      tutorialImage8:this.config.tutorialImage8,
      turorialGuideVideoUrl:this.config.turorialGuideVideoUrl,
      weblinks:this.config.weblinks,
      tutorialPagesNew:this.config.tutorialPagesNew,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch', {
        data: {
          apiDomains: this.apiDomains,
          trackingDomains: this.trackingDomains,
          tutorialUrl: this.tutorialUrl,
          copyDownloadLink:this.copyDownloadLink,
          onboardingImage2:this.onboardingImage2,
          purchaseImg1:this.purchaseImg1,
          qrPurchaseImageRight:this.qrPurchaseImageRight,
          qrPurchaseImageLeft:this.qrPurchaseImageLeft,
          qrWechatButtonIcon:this.qrWechatButtonIcon,
          purchasePopupAlipayImage:this.purchasePopupAlipayImage,
          purchasePopupWechatImage:this.purchasePopupWechatImage,
          accountSupportImage:this.config.accountSupportImage,
          tutorialImage2:this.tutorialImage2,
          tutorialImage3:this.tutorialImage3,
          tutorialImage4:this.tutorialImage4,
          tutorialImage5:this.tutorialImage5,
          tutorialImage6:this.tutorialImage6,
          tutorialImage7:this.tutorialImage7,
          tutorialImage8:this.tutorialImage8,
          turorialGuideVideoUrl:this.turorialGuideVideoUrl,
          weblinks:this.weblinks,
          tutorialPagesNew:this.tutorialPagesNew,
        },
        guid: this.guid,
        appName: this.appName
      })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    containsImage(text) {
      return text.toLowerCase().includes('image');
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
